import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditSecretsWithLevelGroups } from '../services/selectors';

export const useSecurityAuditLevelSecretsList = () => useAppSelector(selectSecurityAuditSecretsWithLevelGroups);
